import { Box, Center, HStack, Spacer, Stack, Text } from '@chakra-ui/react';
import { OrderTemplate } from '@diamond/shared/types';
import { Button, IconButton } from '@diamond/shared/ui';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS, TRACKING_PAGES } from '@diamond/sol-buyer/constant';
import { DeleteOutlined } from '@mui/icons-material';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useRouter } from 'next/router';

export interface MobileTemplateCardProps {
  data: OrderTemplate;
  handleDelete: () => void;
  handleAddtoCart: () => void;
  isLoadingDelete: boolean;
}

export function MobileTemplateCard({
  data,
  handleDelete,
  handleAddtoCart,
  isLoadingDelete,
}: MobileTemplateCardProps) {
  const router = useRouter();

  function handleTemplateDetail(templateId: string, warehouse: string) {
    trackEvent(TRACKING_EVENTS.CLICK_SHOPPING_LIST_DETAIL, {
      section_name: TRACKING_PAGES.SHOPPING_LIST,
    });

    router.push({
      pathname: `/daftar-belanja/${templateId}`,
      query: { warehouse: warehouse, page: 1 },
    });
  }

  function handleClikEdit(templateId: string, warehouse: string) {
    trackEvent(TRACKING_EVENTS.CLICK_EDIT_SHOPPING_LIST, {
      section_name: TRACKING_PAGES.SHOPPING_LIST,
    });

    router.push({
      pathname: `/daftar-belanja/edit/${templateId}`,
      query: { warehouse: warehouse, page: 1 },
    });
  }

  return (
    <Box
      w="full"
      shadow="base"
      rounded="lg"
      position="relative"
      py="0"
      my="24px"
    >
      <Stack>
        <HStack mx="19px" mt="17px" mb="1">
          <IconButton
            data-testid="btn-delete-template"
            onClick={() => handleDelete()}
            p={2}
            aria-label="min"
            name="min"
            icon={<DeleteOutlined />}
            size="xs"
            color="red"
            borderColor="red"
            _hover={{
              bg: 'red',
              color: 'white',
              borderColor: 'red',
            }}
            isLoading={isLoadingDelete}
          />
          <IconButton
            data-testid="btn-edit-template"
            p={2}
            aria-label="min"
            name="min"
            icon={<ModeEditOutlineOutlinedIcon fontSize="medium" />}
            size="xs"
            color="blue"
            _hover={{
              bg: 'white',
              color: 'cyan',
            }}
            onClick={() => handleClikEdit(data.id, data.warehouse_id)}
          />
        </HStack>
        <Box px="19px">
          <Text as={'span'} fontWeight="bold" fontSize="lg">
            {data.name}
          </Text>
          <Text my="16px" color="gray.75" fontSize="14px">
            {data.note}
          </Text>
        </Box>
        <Box p="16px" bg="#F3F4F5" roundedBottom="lg">
          <Center>
            <Button
              fontSize="12px"
              bg="white"
              color="azure"
              borderColor="azure"
              mr="12px"
              w="full"
              variant="outline"
              onClick={() => handleTemplateDetail(data.id, data.warehouse_id)}
              className="btn-see-detail"
            >
              Lihat Detail
            </Button>
            <Spacer />
            <Button
              fontSize="12px"
              w="full"
              bg="blue"
              color="white"
              variant="solid"
              _hover={{
                bg: 'navy',
              }}
              onClick={handleAddtoCart}
            >
              + Keranjang
            </Button>
          </Center>
        </Box>
      </Stack>
    </Box>
  );
}

export default MobileTemplateCard;
